import { Typography, Box, Button } from "@mui/material";
import { useCallback } from "react";
import { useLogoutMutation } from "../app/services/api";
import LogoutTwoToneIcon from "@mui/icons-material/LogoutTwoTone";
import { navigate } from "../app/services/routing";

export default function Logout() {
    const [logout, logoutResult] = useLogoutMutation();

    const onLogoutClick = useCallback(async () => {
        try {
            await logout();
        } finally {
            navigate("start", {}, { replace: true });
        }
    }, []);

    return (
        <>
            <Box>
                <Typography variant="h2" gutterBottom>
                    Is this Goodbye?
                </Typography>
                <Typography variant="body1" gutterBottom>
                    You can log out here in order to end your NL-ix session. Please come back any time!
                </Typography>
            </Box>
            <Button
                fullWidth
                variant="contained"
                color="secondary"
                onClick={onLogoutClick}
                disabled={logoutResult.isLoading}
                endIcon={<LogoutTwoToneIcon />}
            >
                Log Out from NL-ix
            </Button>
        </>
    );
}
